import React, {useEffect, useState} from 'react';
import styles from './index.module.scss'
import Footer from '../../components/footer'
import { MenuFoldOutlined } from '@ant-design/icons';
import NavbarMenus from "../../components/navbarMenus";
import Header from "../../components/header";
import API91 from '../../static/image/API9-1.png'
import API92 from '../../static/image/API9-2.png'
const UpdateLog = () => {
    return (
        <div className={styles.modules}>
            <div className={styles.navbar} id='nav'>
                <NavbarMenus path="faq"></NavbarMenus>
            </div>
            <div className={styles.view} id='chartView'>
                <Header title='常见问题'></Header>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>如何联系我们
                    </div>
                    <p>
                        可以扫码添加我们的工作人员，谢谢
                    </p>
                    <img src={'http://meichuangit.net.cn/wx.jpg'} width={200}/>
                    <p>也可以在B站搜索：<span className={styles.link}>莓创-陈杨</span>。找到我，关注我，私信我</p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>新版本上线之后遇到问题怎么办？
                    </div>
                    <p>
                        我们提供了问题收集表，可以点击问题收集表快速把问题反馈出来，主要提供的内容：<br/>
                        * 出现问题的组件名称<br/>
                        * 出现问题时对应options<br/>
                        * 简单描述一些交互业务<br/>
                        * 留下你的联系方式，或者添加工作人员的QQ<br/>
                    </p>
                    <p>
                        可以点击头部右上角，快速搜集问题按钮
                    </p>
                </div>

                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>关于鸿蒙API9的适配
                    </div>
                    <p>
                        目前我们已经把API9的适配单独打包出来一份，版本为2.8.0。<br/>
                        使用方式如下
                    </p>
                    <p>
                        1. 下载API9的组件包：<a className={styles.link} href={'http://meichuangit.net.cn/mcCharts.zip'}>点击我下载</a><br/>
                    </p>
                    <p>
                        2. 放在这个路径下面：entry\src\main\ets
                    </p>
                    <img src={API91}/>
                    <p>
                        3. 使用相对路径的方式引入，只有引入方式跟官方文档使用不一致，其他的一模一样哈
                    </p>
                    <img src={API92}/>
                    <p>
                        4. 剩下使用方式跟官网的一模一样，复制使用即可
                    </p>
                </div>

                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>针对于版本不同使用不了的问题
                    </div>
                    <p>
                        目前我们组件是基于Build Version: 5.0.3.900进行开发的，如果遇到版本问题，有以下解决方案:<br/>
                        (此方案只针对API10以上的，API10以下的方案等后续)<br/>
                        * 找到图表组件的oh-package.json5文件。路径如下：<br/>
                        * oh_modules/.ohpm/@mcui+mccharts/oh_modules/@mcui/mccharts/oh-package.json5<br/>
                        * 将oh-package.json5文件中的“compatibleSdkVersion”属性改成你们当前版本<br/>
                        * 接下来再找到module.json文件。路径如下：oh_modules/.ohpm/@mcui+mccharts@2.0.9-rc.5/oh_modules/@mcui/mccharts/src/main/module.json<br/>
                        * 将整个内容全部清空，包括"app"属性与"module"属性，就是空对象就好<br/>
                    </p>
                </div>

                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>关于官网的升级
                    </div>
                    <p>
                        本次版本升级之后，官网会在属性讲解中标注当前属性是新增还是已弃用，请认真查看<br />
                        本次对弈必填属性也是重点标注，请认真查看
                    </p>
                </div>

                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>如果遇到卡顿问题，请即时反馈给我们
                    </div>
                    <p>
                        由于目前动画的渲染还属于一个单线程逻辑，我们真正配合华为调研最佳渲染方案，请耐心期待，如果卡顿可以暂时关闭动画
                    </p>
                </div>


                <Footer></Footer>
            </div>
        </div>
    )
}

export default UpdateLog
